<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_17"><b>PART ONE</b></a></p><a id="page_17">
<p class="parttitle"><b>INNOCENCE</b></p>
<p class="center"><i>Oakland, CA &amp; Selma, AL<br/>1990–1993</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?7c65f927